import { FREE_PLAN_PRICE, PRO_PLAN_PRICE, REGULAR_PLAN_PRICE } from '../constants';

export const usePricing = () => {
  const getPlanPrice = (plan: 'regular' | 'pro' | 'free' | 'enterprise') => {
    switch (plan) {
      case 'free':
        return `$${FREE_PLAN_PRICE}`;
      case 'regular':
        return `$${REGULAR_PLAN_PRICE}`;
      case 'pro':
        return `$${PRO_PLAN_PRICE}`;
      case 'enterprise':
        return 'Custom';
      default:
        return '-';
    }
  };

  return {
    getPlanPrice,
  };
};
